var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-h5"},[_c('van-loading',{attrs:{"color":"#1989fa","vertical":"","text-size":"26","size":"26"}},[_vm._v("页面跳转中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }